
export default [
  {
    name:"MessagesIndex",
    path: '/messages/index',
    component: (resolve) => require(['@/views/message/list'], resolve),
    meta: { title: 'Messages', noCache: false, affix: false},
    roles:[0,1,2,9]
  },
  {
    name:"MessagesSend",
    path: '/messages/send',
    hidden:true,
    component: (resolve) => require(['@/views/message/send'], resolve),
    meta: { title: 'Messages', noCache: false, affix: false},
    roles:[0,1,2]
  }
]
